import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import PendingDocsPage from "../../../auxiliary/pending/PendingDocsPage";
import "../../delivery/da.scss";

const DAListPendingDocument = () => {
	const [t] = useTranslation("global");
	const { querySWPurchaseDealerByState } = useDealer();
	return (
		<PendingDocsPage
			title={t("deliveryArea.pending.list.title")}
			prefix="da"
			query={querySWPurchaseDealerByState}
			stateFilter={{ simSwapState: [9] }}
			commissionTitle="پورسانت"
			uploadPath={_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Pending.Index + _adr.DeliveryArea.Pending.upload}
			toRow={(item) => ({
				trackcode: item.stR_SWFollowupCode,
				msisdn: item.inT_MSISDN,
				type: item.stR_BundleName,
				price: complexDigitToman(item.inT_ICCIDWholeSalesPrice),
				commission: complexDigitToman(Math.abs(item.inT_SalesCommission)),
				purchaseDate: convertToJalaliWithTime(item.dtE_OperationDate),
			})}
		/>
	);
};

export default DAListPendingDocument;
